export default "__VITE_ASSET__wJwOkcF8__"